import { Directive, ElementRef, EventEmitter, HostListener, Input, Output, OnChanges } from '@angular/core';

@Directive({
  standalone: false,
  selector: '[stick]'
})
export class StickDirective implements OnChanges {
  private _isStick: boolean;
  private _stickOffset: number;

  private get _minY(): number {
    return this._updateOffset();
  }

  private _className = 'stick';

  @Input() switchOn = true;
  @Input() extraOffset = 0;

  @Input('stickClass') set stickClass(className: string) {
    this._className = className || this._className;
  }

  @Output() onStick = new EventEmitter<boolean>();

  constructor(private _element: ElementRef<HTMLElement>) {
  }

  @HostListener('window:resize')
  handleResize() {
    this._updateOffset();
  }

  @HostListener('window:scroll')
  handleScrollEvent() {
    this._stickCheck();
  }

  ngOnChanges() {
    setTimeout(() => this._stickCheck(), 50);
  }

  private _updateOffset() {
    if (this._isStick) {
      return this._stickOffset;
    }

    return this._stickOffset = this._element.nativeElement.parentElement.offsetTop + this.extraOffset || 100;
  }

  private _stickCheck() {
    this._isStick = window.pageYOffset > this._minY && this.switchOn;

    if (this._isStick) {
      this._element.nativeElement.classList.add(this._className);
    } else if (this._element.nativeElement.classList) { // Added check if element has classList, or loaded enough, if so than remove certain
      this._element.nativeElement.classList.remove(this._className);
    }

    this.onStick.emit(this._isStick);
  }
}
